import { setThemeColorsProperty } from '../../theme/defaultThemeOperators';
import { get } from '../../utils/get';
export const getIconColor = get('icon');
export const setIconColor = setThemeColorsProperty('icon');